import * as firebase from "firebase";
import "firebase/database";

let config = {
    apiKey: "AIzaSyDPw91fsn_49_gUjxTxF-omxyAY9AqZUgM",
    authDomain: "djkrock-48363.firebaseapp.com",
    databaseURL: "https://djkrock-48363-default-rtdb.firebaseio.com",
    projectId: "djkrock-48363",
    storageBucket: "djkrock-48363.firebasestorage.app",
    messagingSenderId: "572973002551",
    appId: "1:572973002551:web:9a8bacebb7e24f5fb734b2",
    measurementId: "G-NW2Z89DQTW"
};

firebase.initializeApp(config);

export default firebase.database();
